export default __webpack_public_path__ + "static/media/98.a9585498.jpg";